import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutComponent } from './about/about.component';
import { AppUiComponent } from './app-ui/app-ui.component';
import { CategoriesComponent } from './categories/categories.component';
import { ContactComponent } from './contact/contact.component';
import { FacebookAdComponent } from './facebook-ad/facebook-ad.component';
import { FacebookCoverComponent } from './facebook-cover/facebook-cover.component';
import { FacebookPostComponent } from './facebook-post/facebook-post.component';
import { InstagramPostComponent } from './instagram-post/instagram-post.component';
import { InstagramRealComponent } from './instagram-real/instagram-real.component';
import { InstagramStoryComponent } from './instagram-story/instagram-story.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { WebsiteUiComponent } from './website-ui/website-ui.component';


const routes: Routes = [
  {
    path:'', component: WebsiteUiComponent
  },
  // {
  //   path:'portfolio', component: CategoriesComponent
  // },
  // {
  //   path:'facebook-cover', component: FacebookCoverComponent
  // },
  // {
  //   path:'facebook-ad', component: FacebookAdComponent
  // },
  // {
  //   path:'facebook-post', component: FacebookPostComponent
  // },
  // {
  //   path:'instagram-post', component: InstagramPostComponent
  // },
  // {
  //   path:'instagram-story', component: InstagramStoryComponent
  // },
  // {
  //   path:'instagram-real', component: InstagramRealComponent
  // },
  // {
  //   path:'app-ui', component: AppUiComponent
  // },
  // {
  //   path:'website-ui', component: WebsiteUiComponent
  // },
  {
    path:'about', component: AboutComponent
  },
  {
    path:'contact', component: ContactComponent
  },
  {
    path:'**', component: PageNotFoundComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
